

export const validationMessage = (value) => {
  return `${value} is required`;
};
export const toFix = (value, n, isPrice = true) => {
  const v = value.toString().split(".");
  if (n <= 0) return v[0];
  let f = v[1] || "";
  if (f.length > n) return `${v[0]}.${f.substr(0, n)}`;
  while (f.length < 2) f += "0";
  if (isPrice) {
    return `$${v[0]}.${f}`;
  }
  return `${v[0]}.${f}`;
};



export const convertOneTokenToOther = async (tokenObj) => {
  try {
    let returnQuantity = 0;

    if (tokenObj.convertToGold.toString() === "true") {
    
      
      returnQuantity =
        (Number(tokenObj.quantity) * Number(tokenObj.silverPrice)) /
        Number(tokenObj.goldPrice);

      // return returnQuantity;
    } else if (tokenObj.convertToSilver.toString() === "true") {
     
    
      returnQuantity =
        (Number(tokenObj.quantity) * Number(tokenObj.goldPrice)) /
        Number(tokenObj.silverPrice);
    }
    return returnQuantity;
  } catch (error) {
    return false;
  }
};
